import { getLogoutUrl } from 'src/utils/env';

export default {
  dashboard: {
    dashboardData: '/api/v2/i18n/statistics/report/advertiser_stat/',
    newDashboardData: '/api/v3/i18n/statistics/report/advertiser_stat/',
    dashboardAudience: '/api/v2/i18n/statistics/promote/advertiser_stat/',
    newDashboardAudience: '/api/v3/i18n/statistics/promote/advertiser_stat/',
    dashboardCost: '/api/v3/i18n/statistics/total/advertiser_stat/',
    dashboardDeparting: '/api/v2/i18n/statistics/promote/advertiser_rectangle_stat/',
    newDashboardDeparting: '/api/v3/i18n/statistics/promote/advertiser_rectangle_stat/',
    dashboardAccountStatus: '/api/v2/i18n/statistics/promote/statistics_overview/',
    newDashboardAccountStatus: '/api/v3/i18n/statistics/promote/statistics_overview/',
    optimizeDashboardAccountStatus: '/api/v3/i18n/statistics/dashboard/statistics_overview/',
    dashboardSuggestion: '/api/v2/i18n/statistics/promote/statistics_suggestion/',
    newDashboardSuggestion: '/api/v3/i18n/statistics/promote/statistics_suggestion/',
    optimizeDashboardSuggestion: '/api/v3/i18n/statistics/dashboard/statistics_suggestion/',
    suggestionFilters: '/api/v2/i18n/statistics/filter/suggestion/',
    newSuggestionFilters: '/api/v3/i18n/statistics/filter/suggestion/',
    getBulletBoardData: '/api/v3/i18n/dashboard/mission_list/',
    getShopifyDialogStatus: '/api/v1/self-serve/guideline/manage/',
    getShopifyType: '/api/v1/self-serve/shopify/adv_type/',
  },
  ad: {
    // adgroup
    info: '/api/v3/i18n/perf/ad/detail/', // todo全部走新接口v3
    update: '/api/v3/i18n/perf/ad/update/',
    create: '/api/v3/i18n/perf/ad/create/',
    newUpdate: '/api/v3/i18n/perf/ad/update/',
    newCreate: '/api/v3/i18n/perf/ad/create/',
    copy: '/api/v3/i18n/perf/ad/copy/',
    nav_list: '/api/v2/i18n/perf/ad/list/',
    ad_list: '/api/v2/i18n/overture/ad/ad_list/',
    operator_map: '/api/v3/i18n/perf/tool/mcc_mnc_v2/', // 运营商的表
    checkAdGroup: '/api/v3/i18n/perf/ad/check/',
    checkNewAdGroup: '/api/v3/i18n/perf/ad/check/',
    update_status: '/api/v3/i18n/overture/ad/update_status/',
    batch_update_bid: '/api/v3/i18n/overture/ad/update/bid/', // 批量修改出价
    action_opts: '/api/v2/i18n/overture/api/get_tetris_action/',
    custom_audience: '/api/v2/i18n/overture/tool/custom_audience/list/',
    suggestion_filter: '/api/v3/i18n/statistics/promote/diagnosis_suggestion/', // adgroup数目
    update_name: context => `/api/v3/i18n/overture/ad/${context.ad_id}/rename/`,
    update_bid: context => `/api/v3/i18n/overture/ad/${context.ad_id}/update_bid/`, // 单个出价
    update_budget: context => `/api/v3/i18n/overture/ad/${context.ad_id}/update_budget/`, // 单个改预算
    update_scheduled_budget: ad_id => `/api/v3/i18n/overture/ad/${ad_id}/update_scheduled_budget/`,
    update_budget_task: context => `/api/v2/i18n/overture/ad/${context.ad_id}/budget_task/update/`,
    procedural_audit_detail: '/api/v2/i18n/perf/creative/material_status/',
    // get_external_actions: '/api/v2/i18n/app/actions/',
    get_app_list: '/api/v3/i18n/app/list/',
    get_pixel_list: '/api/v2/i18n/pixel/list/',
    get_pixel_event_list: '/api/v2/i18n/pixel_event/list/',
    get_pixel_info_by_pixelId: '/api/v3/i18n/pixel/info/',
    get_behavior_list: '/api/v2/i18n/perf/tool/ad_actions/',
    get_action_categort: '/api/v3/i18n/perf/tool/action_category/',
    get_device_model_list: '/api/v3/i18n/perf/tool/device_models/',
    search_interest_keywords: '/api/v3/i18n/optimizer/tool/interest_keywords_i18n/search/',
    get_interest_keywords_info: '/api/v3/i18n/optimizer/tool/interest_keywords_i18n/info/',
    search_keywords: '/api/v3/i18n/optimizer/tool/keywords_i18n/search/',
    get_keywords_info: '/api/v3/i18n/optimizer/tool/keywords_i18n/info/',
    breakdown_report_stat: '/api/v2/i18n/statistics/promote/ad_stat/',
    new_breakdown_report_stat: '/api/v3/i18n/statistics/promote/ad_stat/',
    ttp_breakdown_report_stat: '/api/v3/ttp/statistics/promote/ad_stat/',
    breakdown_download_trail_url: '/api/v2/i18n/statistics/promote/ad_stat/',
    new_breakdown_download_trail_url: '/api/v3/i18n/statistics/promote/ad_stat/',
    breakdown_download_url: '/api/v2/i18n/statistics/data/download_stat/',
    frequency_projected_stat: '/api/v2/i18n/statistics/data/ad_rf_projected/',
    new_frequency_projected_stat: '/api/v3/i18n/statistics/data/ad_rf_projected/',
    frequency_download_trail_url: '/api/v2/i18n/statistics/report/ad_rf_stat/',
    new_frequency_download_trail_url: '/api/v3/i18n/statistics/report/ad_rf_stat/',
    frequency_download_url: '/api/v2/i18n/statistics/data/download_stat/',
    new_frequency_download_url: '/api/v3/i18n/statistics/reporting/download_file/',
    total_cost: '/api/v2/i18n/statistics/promote/total_stat/',
    new_total_cost: '/api/v3/i18n/statistics/promote/total_stat/',
    new_breakdown_download_url: '/api/v3/i18n/statistics/data/download_stat/',
    ttp_breakdown_download_url: '/api/v3/ttp/statistics/data/download_stat/',
    list: '/api/v2/i18n/statistics/data/ad_stat/',
    newList: '/api/v2/i18n/promote/ad/list/',
    newStatisticList: '/api/v3/i18n/statistics/ad/list/',
    suggestions: '/api/v2/i18n/perf/audit/ad/',
    download_url: '/api/v2/i18n/statistics/data/download_stat/',
    new_promote_download_url: '/api/v3/i18n/statistics/data/download_stat/',
    ttp_promote_download_url: '/api/v3/ttp/statistics/data/download_stat/',
    new_download_url: '/api/v2/i18n/promote/task_query/',
    new_statistic_download_url: '/api/v3/i18n/statistics/task_query/',
    report_stat: '/api/v2/i18n/statistics/report/ad_stat/',
    new_report_stat: '/api/v3/i18n/statistics/report/ad_stat/',
    download_trail_url: '/api/v2/i18n/statistics/report/ad_stat/',
    new_download_trail_url: '/api/v3/i18n/statistics/report/ad_stat/',
    checkAppInstallType: '/api/v3/i18n/app/statistic_info/',
    audience_estimate: '/api/v3/i18n/optimizer/audience/user/estimate/',

    app_event_list: '/api/v2/i18n/app/events/',

    budgetRecommend: '/api/v3/i18n/optimizer/diagnosis/budget/recommend/', // 推荐预算接口
    budgetRecommendReturn: '/api/v3/i18n/optimizer/diagnosis/budget/feedback/', // 推荐预算数据回传
    getImpression: '/api/v3/i18n/optimizer/diagnosis/impression/estimate/', // 获取 impression 预估

    audience_analysis_ad: '/api/v2/i18n/statistics/audience/ad_stat/',
    audience_analysis_creative: '/api/v2/i18n/statistics/audience/creative_stat/',
    audience_analysis_compaign: '/api/v2/i18n/statistics/audience/campaign_stat/',
    audience_analysis_download: '/api/v2/i18n/statistics/data/download_stat/',
    new_audience_analysis_download: '/api/v3/i18n/statistics/data/download_stat/',
    ttp_audience_analysis_download: '/api/v3/ttp/statistics/data/download_stat/',
    preview_create: '/api/v2/i18n/create_preview/',
    preview_qr: '/api/v3/i18n/create_preview/preview_qr/',
    package_parse: '/api/v2/i18n/ad/package_parse/',

    image_material_list: '/api/v2/i18n/material/image/list/',
    video_material_list: '/api/v2/i18n/material/video/list/',
    promotion_url_recommend: '/api/v2/i18n/perf/tool/promotions/',
    get_price_suggest: '/api/v2/i18n/ad/optimal_bidding/',
    get_split_price_suggest: '/api/v3/i18n/split_test/ad/optimal_bidding/',
    getSplitTestBudget: '/api/v3/i18n/split_test/budget/estimate/',
    getPower: '/api/v3/i18n/optimizer/split_test/power/estimate/',
    splitTestAuEstimate: '/api/v3/i18n/optimizer/audience/split_test/user/estimate/',
    bulkEditBudgetCheck: '/api/v3/i18n/overture/ad/batch_update/budget/check/',
    bulkEditBudgetUpdate: '/api/v3/i18n/overture/ad/batch_update/budget/',
    bulkEditBidUpdate: '/api/v3/i18n/overture/ad/batch_update/bid/',
    bulkEditBidCheck: '/api/v3/i18n/overture/ad/batch_update/bid/check/',

    bulkExportUrl: '/api/v3/i18n/helper/download/job_launch/', // 批量下载url
    bulkExportPollUrl: '/api/v3/i18n/helper/download/check/', // 批量轮询url
    bulkUploadAds: '/api/v3/i18n/helper/upload/file/', // 批量上传接口
    bulkUploadAdsAnalyse: '/api/v3/i18n/helper/upload/parse/', // 批量创建解析任务接口
    bulkUploadAdsPollAnalyse: '/api/v3/i18n/helper/upload/parse/check/', // 批量轮询解析任务接口
    bulkUploadAdsAnalyseErrorDownload: '/api/v3/i18n/helper/upload/parse/download/', // 下载解析错误报告
    bulkCreateAds: '/api/v3/i18n/helper/upload/create/', // 创建批量创建广告任务接口
    bulkPollCreateAds: '/api/v3/i18n/helper/upload/create/check/', // 轮询批量创建广告任务接口
    bulkCreateAdsErrorDownload: '/api/v3/i18n/helper/upload/create/download/', // 下载批量创建广告错误
    bulkGetIOSNumber: '/api/v3/i18n/helper/after_parse_check/', // 获取iOS14campaign额度
    bulkUserVersion: '/api/v3/i18n/helper/version/', // 批量工具用户账号信息
    bulkExportNum: '/api/v3/i18n/helper/download/check_num/', // 批量导出结果
    bulkUserUpdate: '/api/v3/i18n/helper/version/update/', // 批量工具更新版本
    checkTrackUrl: '/api/v2/i18n/perf/check/track_url/', // 校验监测链接的接口
    adAuditRejectReason: '/api/v3/i18n/perf/audit/info/ad/',
    creativeAuditRejectReason: '/api/v3/i18n/perf/audit/info/creative/',
    adInspectRejectReason: '/api/v3/i18n/inspect/info/ad/', // 诊断建议在suggestion地方的接口
    auditRejectAppeal: '/api/v3/i18n/perf/audit/appeal/', // 一键申诉一期申诉提交GET方法
    auditRejectAppealV2: '/api/v3/i18n/perf/audit/appeal_v2/', // 一键申诉二期POST方法接口
    realLivAuditRejectAppealV2: '/api/v3/i18n/perf/audit/live_appeal/', // 直投直播间申诉post接口
    appealImageUpload: '/api/v3/i18n/perf/audit/appeal_upload/', // 申诉理由图片上传接口
    aeoUnlock: '/api/v3/i18n/perf/tool/third/aeo/', // aeo自动解锁接口
    rfContractTime: '/api/v3/i18n/rf/contract/effective_time/',
    rfOrderCancel: '/api/v3/i18n/rf/order/cancel/',
    stockEstimate: '/api/v3/i18n/rf/stock/estimate/', // 库存预估
    allowCountries: '/api/v3/i18n/manager/country/list/three_tiers_brand_safety/', // 获取standard和limited inventory 支持的定向国家列表
    notifyUserList: '/api/v3/i18n/rf/list_notify_users/', // 订阅邮件通知用户
    suggestBid: '/api/v2/i18n/ad/optimal_bidding/', // cbo需求新添，获取建议出价值
    checkVideoMusic: '/api/v3/i18n/material/video/sensitive_music/', // 获取视频中的敏感音乐信息
    pangleFlowPkg: '/api/v3/i18n/perf/tool/flow_pack/', // 获取pangle流量包信息
    operationSystemList: '/api/v3/i18n/perf/tool/osv/',
    learnParse: '/api/v3/i18n/perf/tool/learn_phase/', // 获取是否在学习期
    campaignQuota: '/api/v3/i18n/app/ios_app/campaign_quota/', // 获取ios14 campaign quota
    getAppIdInWhiteList: '/api/v3/i18n/app/ios_app/v2/new/',
    getIos14AdgroupQuota: '/api/v3/i18n/app/ios_app/v2/campaign_quota/',
    getIos14CampaignQuota: '/api/v3/i18n/app/ios_app/v2/app_quota/',
    targetingRecommendation: '/api/v3/i18n/perf/tool/target_recommendation_tags/', // 定向推荐标签
    /** @description 获取创编定向的语言选项列表 */
    allLanguagesList: '/api/v3/i18n/perf/tool/language_list/',
    getCBOBid: '/api/v3/i18n/perf/tool/cbo_bid/',
    externalUrlDomain: '/api/v3/i18n/pixel/domain/',

    // 获取当前 adGroup 下的创意素材信息  - view data 部分使用
    getMaterialStat: '/api/v3/i18n/statistics/promote/material_stat/',
    // 更新当前创意素材的开关状态
    updateCreativeStatus: '/api/v3/i18n/overture/procedural_material/update_status/',
    updateName: '/api/v3/i18n/overture/ad/batch_update/name/',
    checkName: '/api/v3/i18n/overture/ad/batch_update/name/check/',
    getShadowTags: '/api/v3/i18n/rf/shadow_retargeting_tags/',
    // split test一键放量
    splitTestToAll: '/api/v3/i18n/optimizer/split_test/to_all/',
    // split test关停实验
    splitTestStopTest: '/api/v3/i18n/optimizer/split_test/stop_test/',
    voStatus: '/api/v3/i18n/optimizer/tool/value_optimizer_status/',

    negative_keywords_list: '/api/v3/i18n/search_ads/negative_keyword/list/', // 获取否定关键词列表数据
    add_negative_keywords: '/api/v3/i18n/search_ads/negative_keyword/add/', // 新增否定关键词
    modify_negative_keywords: '/api/v3/i18n/search_ads/negative_keyword/modify/', // 编辑否定关键词
    delete_negative_keywords: '/api/v3/i18n/search_ads/negative_keyword/delete/', // 删除否定关键词
    download_negative_keywords: '/api/v3/i18n/search_ads/negative_keyword/download/', // 导出否定关键词
    // 查询资产可用数量
    assetDetail: '/api/v3/i18n/perf/tool/asset/quota/',
    contextualTags: '/api/v3/i18n/optimizer/tool/contextual_tags/list/',
    contextualTagsInfo: '/api/v3/i18n/optimizer/tool/contextual_tags/info/',
  },
  campaign: {
    info: '/api/v3/i18n/perf/campaign/detail/',
    create: '/api/v3/i18n/perf/campaign/create/',
    update: '/api/v3/i18n/perf/campaign/update/',
    nav_list: '/api/v2/i18n/overture/campaign/campaign_list/',
    update_status: '/api/v2/i18n/overture/campaign/update_status/',

    breakdown_report_stat: '/api/v2/i18n/statistics/promote/campaign_stat/',
    new_breakdown_report_stat: '/api/v3/i18n/statistics/promote/campaign_stat/',
    ttp_breakdown_report_stat: '/api/v3/ttp/statistics/promote/campaign_stat/',
    breakdown_download_trail_url: '/api/v2/i18n/statistics/promote/campaign_stat/',
    new_breakdown_download_trail_url: '/api/v3/i18n/statistics/promote/campaign_stat/',
    breakdown_download_url: '/api/v2/i18n/statistics/data/download_stat/',
    new_breakdown_download_url: '/api/v3/i18n/statistics/data/download_stat/',
    ttp_breakdown_download_url: '/api/v3/ttp/statistics/data/download_stat/',

    new_total_cost: '/api/v3/i18n/statistics/promote/total_stat/',
    newStatisticList: '/api/v3/i18n/statistics/campaign/list/',
    dashboardStatisticList: '/api/v3/i18n/statistics/dashboard/campaignlist/',
    download_url: '/api/v2/i18n/statistics/data/download_stat/',
    new_promote_download_url: '/api/v3/i18n/statistics/data/download_stat/',
    ttp_promote_download_url: '/api/v3/ttp/statistics/data/download_stat/',
    new_download_url: '/api/v2/i18n/promote/task_query/',
    new_statistic_download_url: '/api/v3/i18n/statistics/task_query/',
    report_stat: '/api/v2/i18n/statistics/report/campaign_stat/',
    new_report_stat: '/api/v3/i18n/statistics/report/campaign_stat/',
    download_trail_url: '/api/v2/i18n/statistics/report/campaign_stat/',
    checkCampaign: '/api/v3/i18n/perf/campaign/check/',
    new_download_trail_url: '/api/v3/i18n/statistics/report/campaign_stat/',

    audience_dim_filter: '/api/v2/i18n/statistics/audience/dims_filter/',

    updateName: '/api/v3/i18n/overture/campaign/batch_update/name/',
    checkName: '/api/v3/i18n/overture/campaign/batch_update/name/check/',
    updateBudget: '/api/v3/i18n/overture/campaign/batch_update/budget/',
    checkBudget: '/api/v3/i18n/overture/campaign/batch_update/budget/check/',

    updatePoNumber: '/api/v3/i18n/payment/batch_po_number/',

    negative_keywords_list: '/api/v3/i18n/search_ads/negative_keyword/list/', // 获取否定关键词列表数据
    add_negative_keywords: '/api/v3/i18n/search_ads/negative_keyword/add/', // 新增否定关键词
    modify_negative_keywords: '/api/v3/i18n/search_ads/negative_keyword/modify/', // 编辑否定关键词
    delete_negative_keywords: '/api/v3/i18n/search_ads/negative_keyword/delete/', // 删除否定关键词
    download_negative_keywords: '/api/v3/i18n/search_ads/negative_keyword/download/', // 导出否定关键词
    campaign_list: '/api/v3/i18n/statistics/promotions/coupon/campaign/query/', // campaign list
    assign_campaign: '/api/v3/i18n/coupon/edit/',
  },
  creative: {
    delete: '/api/v2/i18n/overture/creative/update_status/',
    appInfo: '/api/v3/i18n/convert/meteor/app/',
    info: '/api/v2/i18n/perf/creative/detail/',
    new_info: '/api/v3/i18n/perf/creative/detail/',
    new_procedural_info: '/api/v3/i18n/perf/creative/procedural_detail/',
    create: '/api/v3/i18n/perf/creative/create/',
    update: '/api/v3/i18n/perf/creative/update/',
    list: '/api/v2/i18n/perf/creative/list/',
    new_list: '/api/v3/i18n/perf/creative/list/',
    suggestions: '/api/v2/i18n/perf/audit/creative/',
    update_status: '/api/v2/i18n/overture/creative/update_status/',
    verify: '/api/v3/i18n/perf/creative/check/',
    video_repeat_check: '/api/v3/i18n/rf/repeat_video_check/',
    video_generator_check: '/api/v3/i18n/material/video_generator/check/',
    video_generator_check_v2: '/ccapi/tinymovie/meta/i18n/',
    video_info: '/api/v3/i18n/material/video/old_info/',
    catalog_video_info: '/api/shopping/v1/ads_creation/catalog/video/old_info/',
    create_generic: '/api/v3/i18n/material/video_generator/create_generic/',
    video_plum: '/api/v2/i18n/perf/tool/video_plum/',
    cover_process: '/api/v2/i18n/tools/format_image_pattern/',
    music_auth: '/api/v2/i18n/perf/tool/video_music/',
    video_info_v2: '/api/v3/i18n/material/video/info/',
    // v2和v3的区别? v2获取视频信息，会根据 aadvid 做权限校验，只能获取有权限访问的视频信息
    // v3 需要使用 aadvid + tiktok视频授权码，因为此时 aadvid和授权码的关系还没有绑定
    video_info_v3: '/api/v3/i18n/material/tt_video/play_info/',
    /** 素材授权 */
    libAuthIsDefaultOn: '/api/v3/i18n/agreement/creative_authorization/',
    breakdown_report_stat: '/api/v2/i18n/statistics/promote/creative_stat/',
    new_breakdown_report_stat: '/api/v3/i18n/statistics/promote/creative_stat/',
    ttp_breakdown_report_stat: '/api/v3/ttp/statistics/promote/creative_stat/',
    breakdown_download_trail_url: '/api/v2/i18n/statistics/promote/creative_stat/',
    new_breakdown_download_trail_url: '/api/v3/i18n/statistics/promote/creative_stat/',
    breakdown_download_url: '/api/v2/i18n/statistics/data/download_stat/',
    new_breakdown_download_url: '/api/v3/i18n/statistics/data/download_stat/',
    ttp_breakdown_download_url: '/api/v3/ttp/statistics/data/download_stat/',
    statList: '/api/v2/i18n/statistics/data/creative_stat/',
    newStatList: '/api/v2/i18n/promote/creative/list/',
    newStatisticList: '/api/v3/i18n/statistics/creative/list/',
    requiredStatisticList: '/api/v3/i18n/statistics/detail/video_info/', // campaign_creative/list列表页投前指标按需请求video_info
    download_url: '/api/v2/i18n/statistics/data/download_stat/',
    new_promote_download_url: '/api/v3/i18n/statistics/data/download_stat/',
    ttp_promote_download_url: '/api/v3/ttp/statistics/data/download_stat/',
    new_download_url: '/api/v2/i18n/promote/task_query/',
    new_statistic_download_url: '/api/v3/i18n/statistics/task_query/',
    list_from_ad: '/api/v2/i18n/statistics/data/ad_creative_detail/',
    report_stat: '/api/v2/i18n/statistics/report/creative_stat/',
    new_report_stat: '/api/v3/i18n/statistics/report/creative_stat/',
    download_trail_url: '/api/v2/i18n/statistics/report/creative_stat/',
    new_download_trail_url: '/api/v3/i18n/statistics/report/creative_stat/',
    leadAdsForm: '/api/v3/i18n/lead_gen/pages/',
    protocalQuery: '/api/v3/i18n/agreement/lead_gen/query/',
    leadAdsExport: '/api/v3/i18n/statistics/lead/export/create/',
    leadAdsExportDownload: '/api/v3/i18n/statistics/lead/export/download/',
    leadAdsExportDownloadVa: '//ads-va.tiktok.com/api/v3/i18n/statistics/lead/export/download/',
    leadAdsProtocalSign: '/api/v3/i18n/agreement/lead_gen/sign/',
    getLeadAdsFormDetail: '/api/v3/i18n/lead_gen/page_detail/',
    quick_optimization_tools: '/video_kit/quick_optimization',
    optimizeGiveVideoTwo: '/video_kit/optimize-creative-materials', // 赠送视频2.0iframe的URL
    quick_optimization_lite: '/video_kit/quick_optimization_lite',
    precheck: '/api/v3/i18n/material/audit/machine_audit/', // 素材预校验
    batchClipImage: '/api/v3/i18n/material/image/cut/',
    smart_text_tools: '/iframe_pages/smart_text',
    smart_translation_tools: 'https://ads.tiktok.com/iframe_pages/smart_text/translation',
    creative_tools_choose: '/video_kit/choose', // 创意工具入口
    creative_tools_video_editor: '/video_kit/editor', // 创意工具 - 视频编辑器
    front_creative_tool: '/creative/quick_generation',
    getVideoCoverUrisByVids: '/api/v3/i18n/material/video/get_cover_uri/', // 通过vid 批量获取视频封面 URI
    fetchVideoCopyright: '/api/v3/i18n/material/video/copyright/', // 获取视频版权信息
    captureImagesFromVideo: '/api/v3/i18n/material/video/get_video_posters/', // 获取视频封面新接口
    fetchVideoLisFromLibrary: '/api/v3/i18n/creative_platform/video/list/', // 获取当前广告主素材库中所有的视频
    storefrontPageDetail: '/api/v3/i18n/dpa/storefronts_page/detail/',
    protocolQuery: '/api/v3/i18n/agreement/general_query/',
    protocolSign: '/api/v3/i18n/agreement/general_sign/',
    entryNotification: '/creative_tool_server/global/notice',
    leadConnectorAuth: '/lead_connector/api/connection/get/', // 获取 lead ads connector 账号绑定状态
    leadRedirect: '/lead_connector/api/service_provider/', // 根据 page_id 获取三方跳转链接
    getPositionFormatList: '/api/v3/i18n/manager/inventory_flow/get_valid_inventory_flow/', // 获取地域定向下所支持的版位

    // CTA文案优选
    get_cta_recommend_list: '/api/v3/i18n/advanced_creative/asset_recommend/', // 获取推荐CTA列表
    save_cta_optimized_list: '/api/v3/i18n/advanced_creative/portfolio/create/', // 保存CTA智能优选的CTA列表
    get_cta_optimized_detail: '/api/v3/i18n/advanced_creative/portfolio/detail/', // 获取CTA智能优选CTA列表
    copy_cta_optimized_id: '/api/v3/i18n/advanced_creative/portfolio/copy/', // 复制智能优选集选择结果
    fetch_hot_music_list: '/creative_tool_server/music/get_recommend/', // 获取热门音乐列表
    check_video_volume: '/creative_tool_server/music/check_volume/', // 检测视频是否有声音
    app_data: '/api/v3/i18n/perf/tool/app_preview/', // 获取app的星级和评分数信息
    challengeAudit: '/api/v3/i18n/material/audit/challenge_audit/', // 非商业挑战赛标识校验
    urlPrecheck: '/api/v3/i18n/material/audit/machine_audit/urls/', // url预校验
    realTimePrecheck: '/api/v3/i18n/material/audit/machine_audit/realtime/',
    get_playable_info_by_url: '/api/v3/i18n/material/playable/info/', // 根据playable_url获取playable信息
    create_additional_creative_customized_image_card: '/api/v3/i18n/advanced_creative/card/create/', // 创建自定义图片卡片附加创意
    get_additional_creative_card_info: '/api/v3/i18n/advanced_creative/card/detail/', // 获取附加创意卡片信息
    validate_promote_music: '/api/v3/i18n/perf/tool/validate_promote_music/', // 校验视频音乐版权
    get_additional_creative_page_info: '/api/v3/i18n/advanced_creative/custom_instant_page/detail/', // 获取轻落地页信息
    get_additional_creative_engagement_info: creative_id => `/portfolio/query/${creative_id}`, // 获取附加创意信息
    get_additional_creative_info: creative_id => `/portfolio/query/preview/${creative_id}`, // 获取附加创意和平台联动的字段信息（title, 目标页）
    // identity
    identity_list: '/api/v3/i18n/identity/list/', // 获取Identity列表
    identity_list_v2: '/api/v3/i18n/identity/list_v2/',
    identity_save: '/api/v3/i18n/identity/save/', // 新增identity账号
    get_identity_info: '/api/v3/i18n/identity/info/', // 获取identity账号信息详情
    native_video_list: '/api/v3/i18n/material/tt_native_video/list/', // 获取ttba账户/单独授权post的tt账号下的post视频列表
    fetch_video_render_result_by_uids_batch: '/creative_tool_server/task/batch_check', // 通过uid批量获取视频渲染信息
    creative_video_render_task_retry: '/creative_tool_server/task/retry', // 通过task id批量获取视频渲染信息
    batch_change_lib_video_name_by_vid: '/creative_tool_server/material/video/name', // 通过vid批量改视频名称
    fetch_video_bgm_supplement: '/api/v2/i18n/material/video/supplement/', // 获取视频背景音乐所支持的版位（system_tag）
    get_country_number_codes_by_char_codes: '/api/v3/i18n/perf/tool/country_codes/', // 通过国家二字码获取国家数字代码,
    get_custom_instant_page_template_list: '/api/v3/i18n/advanced_creative/instant_page_template/list/',
    // 获取identity的available_status。-1表示解绑or封号（区别于get_identity_info：不使用userid作为查询条件，只校验identity，和当前user无关 ）
    getIdentityStatus: '/api/v3/i18n/identity/available_status/',

    // 站内导流
    getOpenUrl: '/api/v3/i18n/rf/get_open_url/', // 获取直达链接
    getStickerInfo: '/api/v3/i18n/rf/get_sticker_info/', // 获取贴纸开拍页详情
    bsThridPartySupportCountries: '/api/v3/i18n/manager/country/list/brand_safety_post_bid/',
    brandSafetyAuthority: '/api/v3/i18n/perf/tool/validate_postbid_partner/',
    playable_ads_uploader_url: '/creative/playable_tool',
    playable_ads_preview_tool_url: '/creative/playable_tool/preview',
    uploadVideoPrecheckFix: '/creative_tool_server/task/create_new',
    uploadVideoPrecheckFixCheck: '/creative_tool_server/autofix/check/',
    updateName: '/api/v3/i18n/overture/creative/batch_update/name/',
    get_origin_video_info: '/creative_tool_server/global/get_video_info', // 获取视频转码原始信息
    fillImageByBlur: '/api/v3/i18n/material/image/fill/', // 使用模糊填充图片
    checkImageIsCover: '/api/v3/i18n/material/image/check_video_cover/', // 校验图片是否是某个创意的封面
    app_profile_instant_page_editor: '/instant_page/editor',
    custom_instant_page_editor: '/instant_page/editor/templates',
    custom_instant_page_from_library: '/instant_page/editor/library',
    attachment_creative_editor: '/creative/interactive_add_ons/add_ons',
    // smartText
    triggerTitleBlur: '/portfolio/card/derive/trigger',

    // title 标题建议
    smartTitleSuggestion: '/smart_cut_server/api/video/title_suggestion', // 标题建议
    trackTitleSuggestion: '/smart_cut_server/api/video/title_suggestion_event_tracking', // 标题建议埋点接口
    trackSubmitTitleSuggestion: '/smart_cut_server/api/video/title_generation_event_tracking',
    attachmentAsset: '/creative/interactive_add_ons/assets', // 附加创意资产化 iframe src
  },
  transaction: {
    // 交易列表
    list: '/api/v2/i18n/statistics/transaction/records/query/',
    newList: '/api/v3/i18n/statistics/transaction/records/query/',
    export: '/api/v2/i18n/statistics/transaction/records/export/',
    newExport: '/api/v3/i18n/statistics/transaction/records/export/',
    download: '/api/v2/i18n/statistics/transaction/download/',
    newDownLoad: '/api/v3/i18n/statistics/transaction/download/',
    invoice: '/api/v2/i18n/statistics/transaction/invoice/download/',
    new_invoice: '/api/v3/i18n/statistics/invoice/download/',
    paymentsList: '/api/v3/i18n/statistics/v2/transaction/list/',
    costsList: '/api/v3/i18n/statistics/v2/payment/cost/list/',
    taxList: '/api/v3/i18n/statistics/v2/payment/tax/list/',
  },
  account: {
    contact_info: '/api/v3/i18n/account/contact_info/',
    passport: '/passport/web/account/info/',
    permission: '/api/v4/i18n/account/permission/detail/',
    extra: '/api/v3/i18n/account/extra/',
    billing_info: '/api/v3/i18n/account/billing_info/',
    all_timezone_list: '/api/v2/i18n/perf/tool/timezone/',
    info: '/api/v4/i18n/advertiser/info/',
    ad_info: '/api/v2/i18n/overture/index/ad_info/',
    white_list: '/api/v3/i18n/account/features_enabled/',
    notification_msg: '/api/v2/i18n/notification/banner_msg/', // 横幅通知
    advertiser_chart: '/api/v2/i18n/overture/index/advertiser_chart/',
    advertiser_avatar: '/api/v2/i18n/overture/account/advertiser_avatar/',
    /* 通知中心 start */
    get_new_msg: '/api/v2/i18n/notification/get_new_msg/', // 获取新消息
    get_notification: '/api/v2/i18n/notification/list/', // 分页获取所有消息
    get_notification_conf: '/api/v2/i18n/notification/config/', // 获取通知订阅配置
    post_notification_conf: '/api/v2/i18n/notification/config/', // 提交通知订阅配置
    /* 通知中心 end */
    logout: getLogoutUrl(),
    oauth: '/oauth/callback/',
    accountList: '/api/v2/i18n/account/account_switch_list/',
    accountUpdate: '/api/v3/i18n/account/info/',
    firstPostAccountInfo: '/api/v1/self-serve/adv-account/update_account_first_time/', // 自助首次提交资质
    getGeoByCode: '/api/v2/i18n/toponym/',
    getGeoByCodeNew: '/api/v1/self-serve/geography/', // 地理中台 获取国家地理信息
    getReginNameByCode: '/api/v2/i18n/toponym/info/', // toolbox 获取国家地理信息
    cancel_account: '/api/v2/i18n/advertiser/account/disable/', // 销户
    // 校验adv name 是否存在
    name_exist: '/api/v2/i18n/account/name/exist/',
    check_tax_vat: '/api/v3/i18n/account/vat/check/',
    punish_info: '/api/v3/i18n/account/punish_info/', // 获取广告主惩罚消息

    get_industry_nations: '/api/v3/i18n/industry/nations/all/', // 获取国家信息列表
    get_delivery_nations: '/api/v3/i18n/delivery_qualification/nations/', // 获取资质审核国家信息列表
    get_industry_list: '/api/v3/i18n/industry/industries/all/', // 获取行业信息列表
    get_industry_rules_by_nation: '/api/v3/i18n/industry/rules/delivery/', // 根据国家，行业获取资质列表
    get_industry_rules_by_name: '/api/v3/i18n/industry/rules/name/', // 根据资质名称模糊搜索
    get_account_rules: '/api/v3/i18n/industry/rules/overview/', // 获取账号下的资质列表
    post_industry_rule_verify: '/api/v3/i18n/industry/rule/verify/', // 资质送审
    post_industry_rule_delete: '/api/v3/i18n/industry/rule/delete/', // 资质包删除
    dataPrivacy: '/api/v3/i18n/audience/dmp/setting/', // data-privacy
    verificationStatus: '/api/v3/i18n/account/advertiser/tax_value/', // 税务审核状态
    sharkPayment: '/api/v3/i18n/shark/event/', // 风控审核后付费
    IOSDialogDone: '/api/v3/i18n/agreement/general_sign/', // 看过iOS14弹窗的写接口
    dedicatedTime: '/api/v3/i18n/perf/tool/key_time/', // 获取iOS14政策时间
    getQualificationList: '/api/v3/i18n/delivery_qualification/overview/', // 获取资质列表
    deleteQualification: '/api/v3/i18n/delivery_qualification/delete/', // 删除资质列表
    postMedicineQualification: '/api/v3/i18n/delivery_qualification/pharmacy/submit/', // 提交药品资质
    getQualificationUrls: '/api/v3/i18n/delivery_qualification/ticket_url/', // 批量通过secret_file_id获取ticket_url
    getRecordCompanies: '/api/v3/i18n/delivery_qualification/music/record_companies/', // 获取歌曲label/record_company信息
    postMusicQualification: '/api/v3/i18n/delivery_qualification/music/submit/', // 提交音乐资质
    userCustomerName: '/api/v3/i18n/delivery_qualification/music/customer_name/', // 获取广告主customer name字段
    upgradeInfo: '/api/v3/i18n/account/customer/upgrade_info/', // 获取自助客户升级直客客户的状态
    bcOwnDetails: '/api/v2/bm/account/org/id/',
    checkIptTextLanguage: '/api/v3/i18n/material/audit/input_language_audit/', // 根据传入的内容判断文案的语言
    checkHasNeedPostInvoiceInfo: '/api/v3/i18n/account/check_post_fulfill_country/', // 判断是否自助资质弹窗是否有后置填写的内容

    /** ttp 相关 */
    getTTPFlag: '/api/v3/i18n/optimizer/audience/region_info/', // 获取打标情况
    common_tcc: '/api/v1/self-serve/adv-account/get_tcc/', // 自助 tcc，https://bytedance.feishu.cn/wiki/wikcnQy8BZea1dHdNuwVE7e3lnd
    PONumber: '/api/v3/i18n/payment/po_number/', // 查询/更新  po number
    // 判断是否允许变更名字 https://bytedance.feishu.cn/wiki/wikcnG2BncW23Qz4NeN2vj8hFfe
    canChangeBusinessName: '/api/v3/i18n/account/advertiser/is_company_update_allowed/',
    // 查看是否绑定了 ttcm https://bytedance.feishu.cn/wiki/wikcnsHe1tbKceSktZ5rel6ZZhh#doxcnSG0qwSs8UI4cwjt26vJlah
    checkTTCMAccount: '/api/v2/bm/ttam/related/ttcm/',
  },
  bc: {
    bc_manage_list: '/api/v3/i18n/account/bc/manage/',
    account_remove_bc: '/api/v3/i18n/account/bc/remove/',
    billing_info: '/api/v3/i18n/account/billing_info/',
    info: '/api/v3/i18n/account/bc_info/',
    billing_config: '/api/v3/i18n/account/billing_config/',
  },
  payment: {
    balance: '/api/v3/i18n/statistics/transaction/balance/query/', // payment统一余额查询
    rf_balance: '/api/v3/i18n/payment/balance/', // rf专用保留接口，total_balance_valid

    // 后付款
    cardInfo: '/api/v3/i18n/payment/card/info/', // 获取绑卡信息
    credit: '/api/v3/i18n/payment/credit/info/', // 获取信用卡账期信息
    charge_info: '/api/v3/i18n/charge/payment/info/', // 是否有支付权限
    statistics_charge_info: '/api/v3/i18n/statistics/payment/info/', // 统计支付接口
    ready: '/api/v3/i18n/payment/ready/',

    // 授信相关
    get_creditline_quota: '/api/v2/i18n/charge/credit/line/quota/',
    increase_amt_balance: '/api/v2/i18n/charge/credit/line/recharge/',
    get_decrease_state: '/api/v2/i18n/charge/credit/line/decrease/',
    decrease_amt_balance: '/api/v2/i18n/charge/credit/line/decrease/',
    apply_creditline: '/api/v3/i18n/payment/credit/apply/',

    // 先付款
    getChargeTax: '/api/v3/i18n/payment/trial_tax/', // 充值税费试算
    verifyReloadAmount: '/api/v3/i18n/payment/amount/check/',
    threshold_info: '/api/v3/i18n/payment/autopay/threshold/',
    threshold_switch: '/api/v3/i18n/payment/autopay/threshold/switch/',
    // 充值赠款明细
    paymentBalance: '/api/v3/i18n/payment/balance/',
    getBindLink: '/api/v3/i18n/payment/card/', // 获取绑卡地址
    subPrePay: '/api/v3/i18n/payment/redirect/', // 预付款支付
    getPayNowLink: '/api/v3/i18n/payment/pay_now/',
    paymentChange: '/api/v3/i18n/payment/autopay/change/', // 是否可以转移为autopay 支付方式
    canApplyMonthlyInvoiceForSelfServe: '/api/v3/i18n/payment/can_transfer_creditline/', // 自助是否开放 monthly invoice 支付方式
    checkHistoryBill: '/api/v3/i18n/payment/history/credit/info/', // 查询历史账单
    billing_share_banner: '/api/v2/bm/ttam/billing/ttam_banner/',
    stop_billing_setting: '/api/v2/bm/account/billing/setting/stop/',
    get_billing_setting: '/api/v2/bm/account/billing/setting/',
    get_billing_share: '/api/v2/bm/account/billing/sharing/',
    set_billing_setting: '/api/v2/bm/account/billing/setting/setup/',
    get_billing_owner: '/api/v2/bm/ttam/owner/',
    get_change_pay_method: '/api/v3/i18n/payment/change_pay_method/',
  },
  reporting: {
    save_reporting: '/api/v2/i18n/statistics/reporting/template/',
    new_save_reporting: '/api/v3/i18n/statistics/reporting/template/',
    new_run_reporting_trail_url: '/api/v3/i18n/statistics/reporting/run_template/',
    new_run_reporting_download_url: '/api/v3/i18n/statistics/reporting/download_report/',
    reporting_info: '/api/v2/i18n/statistics/reporting/template_info/',
    new_reporting_info: '/api/v3/i18n/statistics/reporting/template_info/',
    delete_reporting: '/api/v2/i18n/statistics/reporting/delete_template/',
    new_delete_reporting: '/api/v3/i18n/statistics/reporting/delete_template/',
    get_templates: '/api/v2/i18n/statistics/reporting/get_templates/',
    new_get_templates: '/api/v3/i18n/statistics/reporting/get_templates/',
    download: '/api/v2/i18n/statistics/reporting/download/',
    new_download: '/api/v3/i18n/statistics/reporting/download/',
    log_info: '/api/v2/i18n/statistics/reporting/log_info/',
    new_log_info: '/api/v3/i18n/statistics/reporting/log_info/',
    // Reporting 模板最近下载时间更新接口
    template_update: '/api/v3/i18n/statistics/reporting/template_update/',
  },
  simplifiedSmb: {
    adgroup: {
      get_user_draft_checked: '/api/v3/i18n/user_draft/get_checked/',
    },
    creative: {
      check_and_update_user_draft: '/api/v3/i18n/user_draft/check_save/?req_src=pc_lite&draft_type=ad_creative',
    },
    all: {
      submit_saved: '/api/v3/i18n/user_draft/submit_saved/?req_src=pc_lite',
    },
  },
  ad_category: '/api/v2/i18n/overture/api/get_ad_category/',
  new_ad_category: '/api/v2/i18n/perf/tool/ad_category/',
  areasList: '/api/v3/i18n/perf/tool/areas_v2/',
  imageUploadUrl: '/api/v3/i18n/tools/upload_image/',
  imageUploadUrlSecret: '/api/v3/i18n/account/upload_image_secret/',
  imageUploadUrlLibrary: '/api/v2/i18n/material/image/upload/',
  enclosureUploadUrl: '/api/v2/i18n/notification/enclosure/upload/',
  enclosureDownload: '/api/v2/i18n/notification/enclosure/download/',
  interestOption: '/api/v3/i18n/optimizer/tool/ad_interest_v2/',
  manageSysMsg: '/api/v2/i18n/notification/system_msg/',
  splashUploadUrl: '/api/v2/i18n/tools/upload_splash/',
  videoCovers: '/api/v2/i18n/tools/video/get_video_cover_url/',
  create_ad: '/api/v2/i18n/advertiser/create/',
  qualification: '/api/v2/i18n/advertiser/qualification/',
  captcha_url: '/api/v2/i18n/captcha/',
  captcha_eamil: '/api/v2/i18n/email_captcha/',
  password_reset: '/api/v2/i18n/password/reset/',
  videoUpload: '/api/v3/i18n/material/video/create/',
  videoUploadKey: '/api/v2/i18n/get_video_upload_key/',
  app_info: '/api/v2/i18n/app_info/get/',
  tea_url: '/api/v2/i18n/tea/',
  bpmRegister: '/api/v2/i18n/bpm/register/',
  industryList: '/api/v2/i18n/advertiser/industry/new_list/',
  selfIndustryList: '/api/v3/i18n/account/industry/self_service_simplified_list/',
  openapi_adver_info: '/api/v2/i18n/openapi/api/user/context/',
  openapi_sign: '/api/v2/i18n/sign/',
  toolbox: {
    logs: '/api/v2/i18n/overture/tool/opt_log/data/',
    convert_create: '/api/v2/i18n/adv_convert/',
    convert_update_status: '/api/v2/i18n/adv_convert_update/status/',
    convert_edit: convertId => `/api/v2/i18n/adv_convert/${convertId}/`,
    conversionUpdate: '/api/v2/i18n/adv_convert_update/part/',
    partnerList: '/api/v2/i18n/track_partner/list/',
    appInfo: '/api/v2/i18n/app_info/get/',
    appInfoUpdate: '/api/v2/i18n/adv_convert_update/app_info/',
  },
  // 组件重构-新接口
  logs_refactor: {
    logs_info: '/api/v3/i18n/opt_log/action_issue/',
    logs_list: '/api/v3/i18n/opt_log/list/',
    // 不带task_id 第一次尝试下载的URL
    download_get_id: '/api/v3/i18n/opt_log/download_task/',
    // 附带task_id 不断轮询下载的URL
    task_download: '/api/v3/i18n/opt_log/download/',
    // dashboard入口的log日志接口迁移
    dashboard_log_list: '/api/v3/i18n/opt_log/data/',
  },
  dmp: '/api/v3/i18n/perf/tool/pushed_cids/',

  custom_content: {
    create: '/api/v2/i18n/statistics/custom/create/',
    newCreate: '/api/v3/i18n/statistics/custom/create/',
    list: '/api/v2/i18n/statistics/custom/list/',
    newList: '/api/v3/i18n/statistics/custom/list/',
    detail: '/api/v2/i18n/statistics/custom/detail/',
    newDetail: '/api/v3/i18n/statistics/custom/detail/',
    delete: '/api/v2/i18n/statistics/custom/delete/',
    newDelete: '/api/v3/i18n/statistics/custom/delete/',
    update: '/api/v2/i18n/statistics/custom/update/',
    newUpdate: '/api/v3/i18n/statistics/custom/update/',
    permission: '/api/v2/i18n/user/permission/',
  },
  library: {
    playable_list: '/api/v3/i18n/material/playable/list/',
    new_playable_list: '/api/v3/i18n/statistics/playable/list/',
    playable_export_create: '/api/v3/i18n/statistics/playable/export/create/',
    playable_export_download: '/api/v3/i18n/statistics/playable/export/download/',
    video_list: '/api/v2/i18n/material/video/list/',
    image_list: '/api/v2/i18n/material/image/list/',
    material_list: '/api/v3/i18n/statistics/material/list/',
    native_list: '/api/v3/i18n/material/native_video/list/',
    tt_user_list: '/api/v3/i18n/material/tt_user_video/list/', // 获取tt用户的视频列表
    export_create: '/api/v3/i18n/statistics/material/export/create/',
    export_download: '/api/v3/i18n/statistics/material/export/download/',

    playable_validate: '/api/v3/i18n/material/playable/validate/',
    playable_validate_result: '/api/v3/i18n/material/playable/validate/result/',
    playable_create: '/api/v2/i18n/material/playable/create/',
    image_create: '/api/v2/i18n/material/image/create/',
    native_create: '/api/v3/i18n/material/tt_video/authorize/',
    get_native_info: '/api/v3/i18n/material/tt_video/info/',
    delete_native_info: '/api/v3/i18n/material/tt_video/delete/',
    double_authorize_native_info: '/api/v3/i18n/material/tt_video/double_authorize/',

    playable_delete: '/api/v3/i18n/material/playable/delete/',
    image_delete: '/api/v3/i18n/material/image/delete/',
    video_delete: '/api/v3/i18n/material/video/delete/',

    playable_update_name: '/api/v3/i18n/material/playable/update/',
    image_update_name: '/api/v3/i18n/material/image/name/',
    video_update_name: '/api/v3/i18n/material/video/name/',

    check_name_exist: '/api/v3/i18n/material/tools/check_name_exist/', // 检查素材名称是否重名
  },
  notify: {
    // 新版通知中心接口
    notify_list: '/api/v3/i18n/notification/list/all/',
    click: '/api/v2/i18n/notification/click/',
    read: '/api/v3/i18n/notification/status/', // 消息已读
    config: '/api/v3/i18n/notification/subscribe/', // 订阅配置
    categoryInfo: '/api/v3/i18n/notification/category/info/', // 未读消息数
    readAll: '/api/v3/i18n/notification/read_all/', // 全部标为已读
    getOne: '/api/v3/i18n/notification/get_one_new/', // 获取一条消息的详细信息
  },
  help: {
    // 帮助中心接口
    article: '//cognition.byteoversea.com/api/knowledge/detail/',
  },

  // 客增系统接口
  crm: {
    customer_info: '/api/v2/i18n/crm/customer_info/',
    register: '/api/v2/i18n/crm/register/',
  },

  whale_token: '/api/v2/i18n/whale_token/',
  lite_open_check: '/api/v2/i18n/wap_lite/account/lite_open_check/',
  // DPA 商品库相关
  catalogue: {
    dpaIndex: '/api/v3/i18n/dpa/',
    getAll: '/api/shopping/v1/ads_creation/catalog/catalogs_for_uid_and_adv/',
    // 现在后端会在接口 url 上拼接商品库 id，需要特殊处理一下，后面使用下面规范统一处理
    catalogInfo: '/api/v3/i18n/dpa/:catalogId/',
    lexicon: platformId => `/api/v3/i18n/dpa/${platformId}/lexicon/`,
    getVideoPackages: platformId => `/api/v3/i18n/dpa/${platformId}/video_package/`,
    getDvgMeta: '/creative_tool_server/kylin/getTemplatesForDPA',
    getPreviewMeta: '/creative_tool_server/dpa/getPreviewMeta',
    getProduct: platformId => `/api/v3/i18n/dpa/${platformId}/product/`,
    getProductList: platformId => `/api/v3/i18n/dpa/${platformId}/product/query/`,
    advancedGetList: platformId => `/api/v3/i18n/dpa/${platformId}/product/query/condition/`,
    getAvailableLocation: '/api/v3/i18n/dpa/available_location/',
    getPreviewData: '/instant_page/api/v1/get_editor_preview_data/',
    checkProductTargetUrl: catalogueId => `/api/v3/i18n/dpa/${catalogueId}/product/check/`,
    deeplinkCheck: id => `/api/v3/i18n/dpa/${id}/deeplink_check/`,
    getVGTemplate: '/creative_tool_server/dpa/getTemplate', // 根据tid获取VG模板
    checkAuthorized: '/api/v3/i18n/dpa/:catalogId/authorized/check/',
    checkAvailable: '/api/shopping/v1/catalog/',
    getProductInfo: '/api/shopping/v1/ads_creation/catalog/product/',
    //
    queryByCondition: '/api/shopping/v1/ads_creation/catalog/product/query_by_condition/',
    productSetList: '/api/shopping/v1/ads_creation/catalog/product_set_list/',
  },
  tanblock: {
    // 穿山甲屏蔽相关接口
    create: '/api/v2/i18n/blocked_app/add/',
    list: '/api/v2/i18n/blocked_app/list/',
    delete: '/api/v2/i18n/blocked_app/del/',
    update: '/api/v2/i18n/blocked_app/update/',
    download: '/api/v2/i18n/blocked_app/download/',
    upload: '/api/v2/i18n/blocked_app/upload/',
    idCode: '/api/v2/i18n/blocked_app/id/',
  },
  splittest: {
    detail: '/api/v3/i18n/perf/campaign/detail/',
    save: '/api/v3/i18n/split_test/meta_data/save/',
    result: '/api/v3/i18n/optimizer/split_test/result/diff/',
    adDetail: '/api/v3/i18n/perf/ad/detail/',
    metrics: '/api/v2/i18n/statistics/data/ad_stat/',
    newMetrics: '/api/v3/i18n/statistics/ad/list/',
    exclude: '/api/v3/i18n/split_test/ad/exclude/',
    total: '/api/v3/i18n/split_test/to_total/',
    optimizeGoal: '/api/v3/i18n/split_test/campaign/optimize_goal/',
  },
  user: {
    // 开户相关
    promotion: '/api/v2/i18n/advertiser/self/promotion/',
    register_v3: '/api/v3/i18n/account/self/register/', // tt_ads新接口
    selfInvite: '/api/v3/i18n/account/invitation_check/', // tt_ads新接口
    postSurvey: '/api/v3/i18n/account/agent/question/', // 提交调查问卷
    athenaInfo: '/athena/api/open/v1/platform/info/', // 获取平台 identify_key、平台下所有版块及版块中的分类
    athenaFormDetail: '/athena/api/open/v1/form/detail/', // 获取对应的雅典娜表单格式
    athenaOrderCreate: '/athena/api/open/v1/order/submit/', // 工单提交
    leadCreate: '/i18n_node/lead/create/', // 留资
    dailycap: '/api/v3/i18n/account/quota/', // 自助判断是否上限
  },
  plan_download: '/api/v3/i18n/helper/download/launch/',
  plan_check: '/api/v3/i18n/helper/download/check/',
  contract: {
    // 合同相关
    getShownContract: '/api/v2/i18n/advertiser/controls/',
    assignDsa: '/api/v2/i18n/advertiser/dsa_sign/',
    getAssignDsaInfo: '/api/v3/i18n/account/dsa_sign_info/',
  },
  smb_support: {
    get_payment_status: '/api/v3/i18n/payment/ready/', // 查看一个广告主是否支付ready(预付费广告主有至少一条充值记录表示支付ready；后付费广告主有绑卡至少一张表示支付ready)
    creation_mode: '/api/v3/i18n/self_serve_customer/status/creation_mode/', // 自助账号选择的创编模式
    statusNotification: '/api/v3/i18n/self_serve_customer/status/pop_up/', // 获取自助广告主各种弹窗状态
  },
  // 关户&退款相关
  close: {
    refund_status: '/api/v3/i18n/account/refund_status/', // 退款状态
    balance: '/api/v3/i18n/account/refund_balanced/', // 退款金额
    submit: '/api/v3/i18n/account/close/', // 发起退款&关户
    check_all_ads_off: '/api/v3/i18n/account/check_all_ads_off/', // check if all ads campaigns are off within last 3 hrs for postpay account
    bill_status: '/api/v3/i18n/account/bill_status/', // get bill status for postpay account
  },
  libra: {
    abtest: '/api/v3/i18n/abtest/get_ab_version/', // libra abtest
    abtestByTraceSid: '/api/v3/i18n/abtest/get_ab_version_by_trace_sid/', // libra abtest divide by trace sid
  },
  rfuSuggestion: {
    getSuggestions: '/api/v3/i18n/optimizer/universal_recommend/suggestion/',
    abtest: '/api/v3/i18n/optimizer/tool/abtest/', // rfu adtest接口
  },
  // 新手引导
  tutorial: {
    get_status: '/api/v3/i18n/tutorial/get_status/',
    update_status: '/api/v3/i18n/tutorial/update_status/',
    email_touch: '/api/v3/i18n/tutorial/email_touch/',
  },
  // 计划诊断
  inspect: {
    diagnosisNobid: '/api/v3/i18n/overture/ad/update/nobid_status/', // nobid 切换接口
    diagnosisConsumption: '/api/v3/i18n/optimizer/diagnosis/v2/consumption/', // 诊断建议中获取消耗转化统计数据的接口
    diagnosisActionHistory: '/api/v3/i18n/optimizer/diagnosis/v2/action/',
    reportDiagnosisAction: '/api/v3/i18n/optimizer/diagnosis/v2/report/',
    diagnosisSuggestion: '/api/v3/i18n/optimizer/diagnosis/v2/suggestion/',
    diagnosisSuggestionBid: '/api/v3/i18n/optimizer/diagnosis/v2/suggest_bid/',
    diagnosisSuggestionBudget: '/api/v3/i18n/optimizer/diagnosis/v2/suggest_budget/',
    lastDate: '/api/v3/i18n/inspect/latest/',
    funnel: '/api/v3/i18n/inspect/funnel/',
    participating: '/api/v3/i18n/inspect/participating/',
    targeting: '/api/v3/i18n/inspect/targeting/',
    auction: '/api/v3/i18n/inspect/auction/',
    ad: '/api/v3/i18n/inspect/ad/',
    overall: '/api/v3/i18n/optimizer/diagnosis/account/', // smb诊断card接口
    editBid: '/api/v3/i18n/overture/ad/batch_update/bid/', // 批量修改bid
    smbReport: '/api/v3/i18n/optimizer/diagnosis/account/report/',
    smbCheck: '/api/v3/i18n/optimizer/diagnosis/account/report/check/',
    diagnosisLibra: '/api/v3/i18n/optimizer/diagnosis/account/abtest/', // 账户 libra 接口 —— PM 刘雨婷
    diagnosisLibraV2: '/api/v3/i18n/optimizer/diagnosis/v2/abtest/', // suggetion libra接口 —— PM 张萌
  },
  // 赠款系统
  promotion_coupon: {
    code_recharge: '/api/v3/i18n/activity/coupon_code_recharge/', // 优惠券核销
    coupon_list: '/api/v3/i18n/activity/activity_info_list/', // 优惠券查询
    deduction_voucher_list: '/api/v3/i18n/statistics/promotions/coupon/lists/', // 抵用券查询
    ad_credits: '/api/v3/i18n/statistics/transaction/balance/ad_credits/', // 广告赠款
    standard_coupons: '/api/v3/i18n/statistics/promotions/standard_coupon/lists/', // 直充券
  },
  // 评论列表相关
  comment: {
    getCommentList: '/api/v3/i18n/comment/query/', // 获取评论列表
    getCommentListNew: '/api/v3/i18n/comment/query_v2/', // 获取评论列表
    updateCommentStatus: '/api/v3/i18n/comment/process/', // 更新评论状态
    getCommentInfoById: '/api/v3/i18n/comment/reference/', // 根据id获取评论信息
    getBlockedWordsList: '/api/v3/i18n/blocked_word/query/', // 查询当前屏蔽的关键词
    deleteBlockedWords: '/api/v3/i18n/blocked_word/delete/', // 删除屏蔽词
    checkBlockedWordsExist: '/api/v3/i18n/blocked_word/pre_check/', // 关键词重名检查
    updateBlockedWord: '/api/v3/i18n/blocked_word/update/', // 更新关键词
    addBlockedWords: '/api/v3/i18n/blocked_word/create/', // 添加关键词
    exportCreateCommentList: '/api/v3/i18n/comment/export/create/', // 生成评论列表文件
    exportDownloadCommentList: '/api/v3/i18n/comment/export/download/', // 下载评论列表报表
    exportCreateBlockedWords: '/api/v3/i18n/blocked_word/export/create/', // 导出关键词
    exportDownloadBlockedWords: '/api/v3/i18n/blocked_word/export/download/', // 下载关键词
    getAdListByKeyword: '/api/v3/i18n/comment/ad/list/', // 获取广告组下拉列表
    getCommentCreate: '/api/v3/i18n/comment/ad/stats/', // 获取广告的创建时间
    getCreativeByKeyword: '/api/v3/i18n/comment/creative/list/', // 获取广告下拉列表
    getTopComment: '/api/v3/i18n/comment/top/', // 获取置顶评论
    setTopComment: '/api/v3/i18n/comment/pin/', // 设置置顶评论
    replyComment: '/api/v3/i18n/comment/reply/', // 回复评论
    deleteComment: '/api/v3/i18n/comment/delete/', // 删除评论
    getCommentUserInfo: '/api/v3/i18n/identity/user_info/', // 获取当前广告主对应ad identity信息
    getCommonWords: '/api/v3/i18n/common_word/query/', // 获取常用语列表
    exportCreateCommonWords: '/api/v3/i18n/common_word/export/create/', // 导出常用语
    exportDownloadCommonWords: '/api/v3/i18n/common_word/export/download/', // 下载常用语
    deleteCommonWords: '/api/v3/i18n/common_word/delete/', // 删除常用语
    checkCommonWordsExist: '/api/v3/i18n/common_word/pre_check/', // 常用语重名检查
    addCommonWords: '/api/v3/i18n/common_word/create/', // 新增常用语
    updateCommonWords: '/api/v3/i18n/common_word/update/', // 编辑常用语
    updateLikeComments: '/api/v3/i18n/comment/action/', // 点赞/取消点赞评论
  },
  // campaign planer
  efficientTool: {
    createPlan: '/api/v3/i18n/optimizer/campaign_planner/plan/create/',
    getPlan: '/api/v3/i18n/optimizer/campaign_planner/plan/query/',
    createVersion: '/api/v3/i18n/optimizer/campaign_planner/version/create/',
    updateVersion: '/api/v3/i18n/optimizer/campaign_planner/version/update/',
    getVersion: '/api/v3/i18n/optimizer/campaign_planner/version/query/',
  },
  // shop monetization
  shop: {
    getStore: '/api/v3/i18n/dpa/shops/',
    getStoreInfo: '/api/v3/i18n/dpa/shop_info/',
    getSpuProduct: catalogId => `/api/v3/i18n/dpa/${catalogId}/spu/search/`,
    createProductSet: catalogId => `/api/v3/i18n/dpa/${catalogId}/spu/set/`,
    getShopCount: '/api/shopping/v1/ads_creation/shop_count',
  },
  instantPage: {
    getTemplateList: '/instant_page/api/v2/template/list/',
    getTemplateInfo: '/instant_page/api/v2/template/info/',
    create: '/instant_page/api/v1/one2n/create/',
    publish: pageId => `/instant_page/api/v1/one2n/publish/${pageId}/`,
    getShopAdsPreviewData: '/instant_page/api/v1/shopping_ads/get_shop_ads_preview_data/',
  },
  // 缓存相关接口
  draft: {
    // 调用check接口会把数据存在redis,保存两个小时
    getCheckedDraft: '/api/v3/i18n/perf/draft/get_checked_data/', // 根据 fakeId 查草稿
    deleteDraft: '/api/v3/i18n/perf/draft/delete/', // 删除草稿
  },
  rf_apply: '/api/v4/i18n/brand/rf/apply_access_rf/',
};
